import axios from 'axios'
import _ from 'lodash'
let API_URI = 'http://dls.test/api'
if (process.env.NODE_ENV === 'production') {
    API_URI = '/api'
}

export const api = {
    auth: {
        attemptLogin: (auth) => {
            return axios.post(`${API_URI}/auth/login`, auth)
        },
        resetPassword: (email) => {
            return axios.post(`${API_URI}/auth/reset/request`, email)
        },
        postResetRequest: (reset) => {
            return axios.post(`${API_URI}/auth/reset/confirm`, reset)
        }
    },

    dashboard: {
        my: (jwt) => {
            return axios.get(`${API_URI}/dashboard/my-order`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        pendingOrder: (jwt) => {
            return axios.get(`${API_URI}/dashboard/pending-order`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        pendingReceiving: (jwt) => {
            return axios.get(`${API_URI}/dashboard/pending-receiving`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        pendingShipping: (jwt) => {
            return axios.get(`${API_URI}/dashboard/pending-shipping`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        pendingQb: (jwt) => {
            return axios.get(`${API_URI}/dashboard/pending-qb`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        }
    },

    system: {
        status: (jwt) => {
            return axios.get(`${API_URI}/status`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        resources: (jwt) => {
            return axios.get(`${API_URI}/resources`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },

        carriers: (jwt) => {
            return axios.get(`${API_URI}/u/carriers`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    integrations: {
        fetchLog: (jwt, params, id) => {
            return axios.get(`${API_URI}/integrations/${id}/logs?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },

        loadQbMapping: (jwt) => {
            return axios.get(`${API_URI}/integrations/qb/mapping`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        fetchQbTax: (jwt,reload) => {
            let endpoint = `${API_URI}/integrations/qb/taxes`;
            if (reload) {
                endpoint = `${API_URI}/integrations/qb/taxes?reload=true`
            }
            console.log(endpoint);
            return axios.get(endpoint, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        fetchQbTerm: (jwt,reload) => {
            let endpoint = `${API_URI}/integrations/qb/terms`;
            if (reload) {
                endpoint = `${API_URI}/integrations/qb/terms?reload=true`
            }
            return axios.get(endpoint, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        fetchQbAccount: (jwt,reload) => {
            let endpoint = `${API_URI}/integrations/qb/accounts`;
            if (reload) {
                endpoint = `${API_URI}/integrations/qb/accounts?reload=true`
            }
            return axios.get(endpoint, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        fetchQbClass: (jwt,reload) => {
            let endpoint = `${API_URI}/integrations/qb/classes`;
            if (reload) {
                endpoint = `${API_URI}/integrations/qb/classes?reload=true`
            }
            return axios.get(endpoint, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },

        updateQbMapping: (jwt, data) => {
            return axios.post(`${API_URI}/integrations/qb/mapping`,data, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },

        updateQbTaxMapping: (jwt, data) => {
            return axios.post(`${API_URI}/integrations/qb/taxes`,{data: data}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },

        retryFailedLog: (jwt, id, logId) => {
            return axios.put(`${API_URI}/integrations/${id}/retry/${logId}`,{}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    inventory: {
        onOrder: (jwt, id) => {
            return axios.get(`${API_URI}/inventories/${id}/on-order`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/inventories?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        selector: (jwt, params) => {
            return axios.post(`${API_URI}/resources/inventories`,params, {
                headers: {
                    'X-Auth-Token': jwt
                }
            }).then( res => {
                const {data} = res.data;
                const options = [];
                _.each(data, item => {
                    options.push({
                        id: item.id,
                        key: item.id,
                        title: item.sku,
                        description: item.name,
                        price: item.upc,
                        inventory: item
                    })
                })
                return options;
            }).catch( err => {
                throw err
            })
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/inventories/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        create: (jwt, model) => {
            return axios.post(`${API_URI}/inventories`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        update: (jwt, model) => {
            return axios.put(`${API_URI}/inventories/${model.id}`,model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        adjust: (jwt, adjustmentModel) => {
            return axios.post(`${API_URI}/inventories/adjust`, adjustmentModel, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        history: (jwt, id, page = 1) => {
            return axios.get(`${API_URI}/inventories/${id}/history?page=${page}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        syncWithHost: (jwt, id) => {
            return axios.put(`${API_URI}/inventories/${id}/hostscm`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        importRandmar: (jwt, shopifyId) => {
            return axios.post(`${API_URI}/inventories/util/randmar`, {shopify_product_id: shopifyId}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    warehouse: {
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/warehouses?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/warehouses/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        create: (jwt, model) => {
            return axios.post(`${API_URI}/warehouses`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        update: (jwt, model) => {
            return axios.put(`${API_URI}/warehouses/${model.id}`,model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    relation: {
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/relations?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        loadWooUnmapped: (jwt) => {
            return axios.get(`${API_URI}/integrations/customers/woo/unmapped`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/relations/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        create: (jwt, model) => {
            return axios.post(`${API_URI}/relations`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        update: (jwt, model) => {
            return axios.put(`${API_URI}/relations/${model.id}`,model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        selector: (jwt, params) => {
            return axios.post(`${API_URI}/resources/relations`,params, {
                headers: {
                    'X-Auth-Token': jwt
                }
            }).then( res => {
                const {data} = res.data;
                const options = [];
                _.each(data, item => {
                    options.push({
                        key: ''+item.id,
                        text: `${item.account} - ${item.company_name} (${item.email}) (${item.phone})`,
                        value: ''+item.id
                    })
                })
                return options;
            }).catch( err => {
                throw err
            })
        },
        history: (jwt, relationId, search, page) => {
            return axios.get(`${API_URI}/relations/${relationId}/orders/history?search=${search}&page=${page}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        toShopify: (jwt, id) => {
            return axios.put(`${API_URI}/relations/${id}/shopify`, {} , {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        notes: {
            add: (jwt, relationId, note) => {
                return axios.post(`${API_URI}/relations/${relationId}/notes`, {
                    note: note
                }, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            update: (jwt, relationId, noteId, note) => {
                return axios.put(`${API_URI}/relations/${relationId}/notes/${noteId}`,{
                    note: note
                }, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            delete: (jwt, relationId, noteId) => {
                return axios.delete(`${API_URI}/relations/${relationId}/notes/${noteId}`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            }
        },
        address: {
            fetch: (jwt, disabled, relationId) => {
                return axios.get(`${API_URI}/relations/${relationId}/addresses${disabled ? '/disabled' : ''}`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            create: (jwt, model) => {
                return axios.post(`${API_URI}/relations/${model.relation_id}/addresses`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            update: (jwt, model) => {
                return axios.put(`${API_URI}/relations/${model.relation_id}/addresses/${model.id}`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            }
        },
        contact: {
            fetch: (jwt, disabled, relationId) => {
                return axios.get(`${API_URI}/relations/${relationId}/contacts${disabled ? '/disabled' : ''}`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            create: (jwt, model) => {
                return axios.post(`${API_URI}/relations/${model.relation_id}/contacts`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            update: (jwt, model) => {
                return axios.put(`${API_URI}/relations/${model.relation_id}/contacts/${model.id}`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            }
        },
        pricing: {
            fetch: (jwt, relationId) => {
                return axios.get(`${API_URI}/relations/${relationId}/inventories`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            getById: (jwt, relationId, inventoryId) => {
                return axios.get(`${API_URI}/relations/${relationId}/inventories/${inventoryId}`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            create: (jwt, model) => {
                return axios.post(`${API_URI}/relations/${model.relation_id}/inventories/${model.inventory_id}`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            update: (jwt, model) => {
                return axios.put(`${API_URI}/relations/${model.relation_id}/inventories/${model.inventory_id}`, model, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            },
            delete: (jwt, relationId, inventoryId) => {
                return axios.delete(`${API_URI}/relations/${relationId}/inventories/${inventoryId}`, {
                    headers: {
                        'X-Auth-Token': jwt
                    }
                })
            }
        }
    },

    order: {
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/orders?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/orders/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        create: (jwt, model) => {
            return axios.post(`${API_URI}/orders/complete`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        update: (jwt, model) => {
            return axios.put(`${API_URI}/orders/complete/${model.id}`,model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        cancelBo: (jwt, id) => {
            return axios.put(`${API_URI}/orders/${id}/cancelbo`, {} ,{
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        addLine: (jwt, line, orderId) => {
            return axios.post(`${API_URI}/orders/${orderId}/lines`, line, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        deleteLine: (jwt, orderId, lineId) => {
            return axios.delete(`${API_URI}/orders/${orderId}/lines/${lineId}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        updateStatus: (jwt, id, status) => {
            ///orders/{id}/status
            return axios.put(`${API_URI}/orders/${id}/status`,{status}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        putOnHold: (jwt, id, reason) => {
            return axios.put(`${API_URI}/orders/${id}/hold`,{reason}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        cancelOnHold: (jwt, id) => {
            return axios.put(`${API_URI}/orders/${id}/unhold`,{}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        addNote: (jwt, orderId, data) => {
            return axios.post(`${API_URI}/orders/${orderId}/note`, data, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        deleteNote: (jwt, orderId, noteId) => {
            return axios.delete(`${API_URI}/orders/${orderId}/note/${noteId}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        clonePo: (jwt,orderId) => {
            return axios.put(`${API_URI}/orders/${orderId}/clone`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    shipment: {
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/shipments?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        create: (jwt, shipment, orderId) => {
            return axios.put(`${API_URI}/orders/${orderId}/shipment`, shipment, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/shipments/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        updateCarrier: (jwt, id, carrier) => {
            return axios.put(`${API_URI}/shipments/${id}/carriers`,carrier, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        fulfill: (jwt, id) => {
            return axios.put(`${API_URI}/shipments/${id}/fulfill`,{}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        unFulfill: (jwt, id) => {
            return axios.put(`${API_URI}/shipments/${id}/unfulfill`,{}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        delete: (jwt, id) => {
            return axios.delete(`${API_URI}/shipments/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        credit: (jwt, id, data) => {
            return axios.put(`${API_URI}/shipments/${id}/credit`, {data}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        fetchTransaction: (jwt, params) => {
            return axios.get(`${API_URI}/transactions?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        exportToQb: (jwt, ids) => {
            return axios.post(`${API_URI}/integrations/qb/export`, {ids: ids}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateDocNumber: (jwt, id, number) => {
            return axios.put(`${API_URI}/shipments/${id}/invoice`, {number: number}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updatePricing: (jwt, orderId, data) => {
            return axios.put(`${API_URI}/orders/${orderId}/line-pricing`, {data: data}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        addFreightCharge: (jwt, shipmentId, price) => {
            return axios.put(`${API_URI}/shipments/${shipmentId}/freight-charge`, {price: price}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateInvoideDate: (jwt, shipmentId, date) => {
            return axios.put(`${API_URI}/shipments/${shipmentId}/invoice-date`, {date: date}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateTaxCodeOnOrder: (jwt, shipmentId, taxId) => {
            return axios.put(`${API_URI}/shipments/${shipmentId}/tax-code`, {tax_id: taxId}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        processInHostScm: (jwt, id) => {
            return axios.put(`${API_URI}/shipments/${id}/hostscm`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        createInHostScm: (jwt, id) => {
            return axios.put(`${API_URI}/shipments/${id}/hostscm/create`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    user: {
        fetch: (jwt, params) => {
            return axios.get(`${API_URI}/admin/users?${params}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        loadModel: (jwt, id) => {
            return axios.get(`${API_URI}/admin/users/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        create: (jwt, model) => {
            return axios.post(`${API_URI}/admin/users`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        update: (jwt, model) => {
            return axios.put(`${API_URI}/admin/users/${model.id}`,model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateMyProfile: (jwt, me) => {
            return axios.post(`${API_URI}/profile`, me, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    pdf: (jwt, params) => {
        return axios.post(`${API_URI}/print`, params, {
            headers: {
                'X-Auth-Token': jwt
            }
        });
    },

    report: (jwt, data) => {
        return axios.post(`${API_URI}/reports`, data, {
            headers: {
                'X-Auth-Token': jwt
            }
        });
    },

    email: {
        send: (jwt,id, data) => {
            return axios.put(`${API_URI}/email/${id}`,data, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        invoice: (jwt, ids) => {
            return axios.post(`${API_URI}/email/invoices`,{ids: ids}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    },

    ecommerce: {
        sprItemToInventory: (jwt, id) => {
            return axios.put(`${API_URI}/spr/products/${id}/to-inventory`, {} , {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        getSprHistory: (jwt) => {
            return axios.get(`${API_URI}/spr/upload`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        uploadNewFile: (jwt,data) => {
            return axios.post(`${API_URI}/spr/upload`, data, {
                headers: {
                    'X-Auth-Token': jwt
                }
            });
        },
        deleteTask: (jwt, id) => {
            return axios.delete(`${API_URI}/spr/upload/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        startProcessing: (jwt, id) => {
            return axios.put(`${API_URI}/spr/upload/${id}`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        getSprProducts: (jwt, query) => {
            return axios.get(`${API_URI}/spr/products?${query}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        getSprByProductId: (jwt,id) => {
            return axios.get(`${API_URI}/spr/products/${id}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateSprProductById: (jwt, model) => {
            return axios.put(`${API_URI}/spr/products/${model.id}`, model, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        getSprUploadReport: (jwt, id, type) => {
            return axios.get(`${API_URI}/spr/upload/${id}/report/${type}`, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        updateShopifyImage: (jwt, id) => {
            return axios.put(`${API_URI}/spr/products/${id}/shopify/images`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        },
        manualImportFromSpr: (jwt, id) => {
            return axios.put(`${API_URI}/spr/products/${id}/manual`, {}, {
                headers: {
                    'X-Auth-Token': jwt
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/api.js